import "./appToast.css";

const ICONOS = {
  success: "pi-check",
  error: "pi-times",
  warn: "pi-exclamation-triangle",
  info: "pi-info-circle",
};

export default function AppToast({
  titulo,
  mensaje,
  severity = "info",
  icono,
}) {
  return (
    <div className="app-toast-contenido">
      <span className={`app-toast-icono ${severity}`} aria-hidden="true">
        <i className={`pi ${icono || ICONOS[severity] || ICONOS.info}`} />
      </span>
      <div className="app-toast-texto">
        <strong>{titulo}</strong>
        <span>{mensaje}</span>
      </div>
    </div>
  );
}
